// src/components/AboutUsBanner.js
import React from 'react';
import './EventBanner.css'; // We’ll define styles separately

const DetailsBanner = () => {
  return (
    <div className="service-banner text-white d-flex align-items-center">
      <div className="container text-center">
        <h2 className="display-4 fw-bold mt-5">Artist Management </h2>
       
      </div>
    </div>
  );
};

export default DetailsBanner;
